export const LOCAL_STORAGE_KEY = "SUNDAESWAP_WALLET_REACT_LOCAL_CACHE";
//# sourceMappingURL=localStorage.js.map